(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const scrollToHashCard = () => {
    const url = new URL(window.location.href);

    if (!url.hash) return;

    const card = document.getElementById(url.hash.slice(1));
    if (card) {
      card.scrollIntoView({ behavior: 'auto' });
    }
  };

  const initCollectionSidebars = (root = document) => {
    let sections = [];

    if (root instanceof Element && root.matches('[data-collection-sidebar-section]')) {
      sections = [root];
    } else if (root && root.querySelectorAll) {
      sections = root.querySelectorAll('[data-collection-sidebar-section]');
    }

    sections.forEach((section) => {
      if (section.dataset.sidebarInitialized === 'true') return;

      const toggleButton = section.querySelector('[data-sidebar-toggle]');
      const sidebar = section.querySelector('[data-sidebar]');

      if (!toggleButton || !sidebar) return;

      section.dataset.sidebarInitialized = 'true';

      const openLabel =
        toggleButton.getAttribute('data-label-open') || 'Afficher les menus';
      const closeLabel =
        toggleButton.getAttribute('data-label-close') || 'Masquer les menus';

      const setState = (isOpen) => {
        sidebar.classList.toggle('is-open', isOpen);
        toggleButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        toggleButton.textContent = isOpen ? closeLabel : openLabel;
      };

      setState(false);

      toggleButton.addEventListener('click', () => {
        const isOpen = !sidebar.classList.contains('is-open');
        setState(isOpen);
      });
    });
  };

  const initCollectionSectionUi = () => {
    scrollToHashCard();
    initCollectionSidebars(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionSectionUi, { once: true });
  } else {
    initCollectionSectionUi();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCollectionSidebars(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
